// Custom JS for LibertyPaw
(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 900px)").matches;
  }

  function closeAllDropdowns() {
    document
      .querySelectorAll(".custom-header-menu-item.has-children.open")
      .forEach(function (item) {
        item.classList.remove("open");
      });
  }

  function initializeCustomHeader() {
    if (!window.Alpine || !Alpine.store("modals")) return;

    if (document.querySelector(".custom-header-wrapper")) {
      const leftDrawer = document.getElementById("left-drawer-slot");
      if (!leftDrawer) return;
      try {
        Alpine.store("modals").register("nav", "leftDrawer");
      } catch (error) {}
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initializeCustomHeader();
    setTimeout(function () {
      if (window.Alpine && Alpine.store("modals")) {
        initializeCustomHeader();
      }
    }, 100);
  });

  document.addEventListener("alpine:init", function () {
    initializeCustomHeader();
  });

  // Fallback sidebar functions
  window.closeSimpleSidebar = function () {
    const simpleSidebar = document.getElementById("simple-sidebar-nav");
    if (simpleSidebar) simpleSidebar.style.display = "none";
    if (window.Alpine && Alpine.store("modals")) {
      Alpine.store("modals").close("nav");
    }
  };

  window.openSimpleSidebar = function () {
    const simpleSidebar = document.getElementById("simple-sidebar-nav");
    if (simpleSidebar) {
      simpleSidebar.style.display = "block";
      setTimeout(function () {
        simpleSidebar.addEventListener("click", function (e) {
          if (e.target === simpleSidebar) window.closeSimpleSidebar();
        });
      }, 100);
    }
  };

  // Desktop nav dropdown handlers
  var menuItems = document.querySelectorAll(
    ".custom-header-menu-item.has-children"
  );

  menuItems.forEach(function (item) {
    var button = item.querySelector(".custom-header-menu-link.has-dropdown");
    var submenu = item.querySelector(".custom-header-submenu");
    if (!button || !submenu) return;

    item.addEventListener("mouseenter", function () {
      if (!isMobile()) {
        closeAllDropdowns();
        item.classList.add("open");
      }
    });

    item.addEventListener("mouseleave", function () {
      if (!isMobile()) item.classList.remove("open");
    });

    button.addEventListener("click", function (e) {
      if (isMobile()) {
        e.preventDefault();
        var isOpen = item.classList.contains("open");
        closeAllDropdowns();
        if (!isOpen) item.classList.add("open");
      }
    });

    submenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        if (isMobile()) item.classList.remove("open");
      });
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-header-menu-item.has-children")) {
      closeAllDropdowns();
    }
  });

  window.addEventListener("resize", closeAllDropdowns);
})();

// =========================
// Cart Drawer
// =========================

window.fixCartDrawer = function () {
  const waitForAlpine = () =>
    new Promise((resolve) => {
      if (window.Alpine && Alpine.store("modals")) {
        resolve();
      } else {
        const check = () => {
          if (window.Alpine && Alpine.store("modals")) resolve();
          else setTimeout(check, 50);
        };
        check();
      }
    });

  waitForAlpine().then(() => {
    const modals = Alpine.store("modals");
    if (!modals.isRegistered("cart")) modals.register("cart", "rightDrawer");

    const cartButton = document.querySelector("#CartButton");
    if (cartButton) {
      cartButton.onclick = null;
      cartButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        try {
          modals.open("cart");
          setTimeout(() => {
            if (!modals.rightDrawer.open || modals.rightDrawer.contents !== "cart") {
              modals.open("cart");
            }
          }, 100);
        } catch (error) {}
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  checkAndHideSorting();
  setTimeout(() => {
    window.fixCartDrawer();
    checkAndHideSorting();
  }, 1000);
});

// =========================
// Mobile Search Popover
// =========================

document.addEventListener("alpine:init", () => {
  Alpine.store("searchPopover", {
    open() {
      const searchPopover = document.querySelector('[x-data*="searchPopoverOpen"]');
      if (searchPopover?._x_dataStack) {
        const component = searchPopover._x_dataStack[0];
        if (component && typeof component.searchPopoverOpen !== "undefined") {
          component.searchPopoverOpen = true;
          setTimeout(() => {
            const input = searchPopover.querySelector('input[type="search"]');
            if (input) { input.focus(); input.select(); }
          }, 100);
        }
      }
    },
    close() {
      const searchPopover = document.querySelector('[x-data*="searchPopoverOpen"]');
      if (searchPopover?._x_dataStack) {
        const component = searchPopover._x_dataStack[0];
        if (component && typeof component.searchPopoverOpen !== "undefined") {
          component.searchPopoverOpen = false;
        }
      }
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const searchIcon = document.querySelector(".custom-header-search-icon");
  if (searchIcon) {
    searchIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.Alpine && Alpine.store("searchPopover")) {
        Alpine.store("searchPopover").open();
      } else {
        const searchPopover = document.querySelector('[x-data*="searchPopoverOpen"]');
        if (searchPopover) {
          searchPopover.dispatchEvent(new CustomEvent("openSearchPopover"));
        }
      }
    });
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && window.Alpine && Alpine.store("searchPopover")) {
    Alpine.store("searchPopover").close();
  }
});

document.addEventListener("click", function (e) {
  const searchPopover = document.querySelector('[x-data*="searchPopoverOpen"]');
  const searchIcon = document.querySelector(".custom-header-search-icon");
  if (searchPopover && !searchPopover.contains(e.target) && !searchIcon?.contains(e.target)) {
    if (window.Alpine && Alpine.store("searchPopover")) {
      Alpine.store("searchPopover").close();
    }
  }
});

// =========================
// Collection Filters & Sort
// =========================

document.addEventListener("DOMContentLoaded", function () {
  // LibertyPaw 2026-09-25 (audit item A24): one set of delegated listeners for both
  // filter forms. Each action uses the form the shopper actually used (the old code
  // always read the desktop form, so the phone drawer re-applied stale filters).
  // Desktop: a tick or a price change applies at once. Phone drawer: a tick only
  // keeps the two forms in step; the shopper presses Apply.
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!form || !form.matches || !form.matches("#Facet-Filters-Form, #Facet-Filters-Form-Mobile")) return;
    if (!form.closest("[data-lp-collection-filters]")) return;
    e.preventDefault();
    applyFilters(form);
  });

  document.addEventListener("change", function (e) {
    const form = e.target.closest ? e.target.closest("#Facet-Filters-Form, #Facet-Filters-Form-Mobile") : null;
    if (!form || !form.closest("[data-lp-collection-filters]")) return;
    if (!e.target.name || e.target.name.indexOf("filter.") !== 0) return;
    if (form.id === "Facet-Filters-Form") applyFilters(form);
    else if (validateFacetPrices(form)) syncFilterForms(form);
  });

  document.addEventListener("input", function (e) {
    const form = e.target.closest ? e.target.closest("#Facet-Filters-Form, #Facet-Filters-Form-Mobile") : null;
    if (!form || !e.target.name || e.target.name.indexOf("filter.v.price.") !== 0) return;
    form.querySelectorAll('input[name^="filter.v.price."]').forEach((input) => input.setCustomValidity(""));
  });

  document.addEventListener("click", function (e) {
    const clear = e.target.closest ? e.target.closest("[data-lp-clear-filters]") : null;
    if (!clear) return;
    const form = clear.closest("form");
    if (!form || !form.closest("[data-lp-collection-filters]")) return;
    e.preventDefault();
    clearFilterForm(form);
    applyFilters(form);
  });

  // Back/Forward after an AJAX filter: reload only when the address (path + query)
  // differs from what the grid shows. Hash-only moves such as the "skip to content"
  // link never reload.
  if (document.querySelector("[data-lp-collection-filters]")) {
    lpFacetRendered = window.location.pathname + window.location.search;
    window.addEventListener("popstate", function () {
      if (window.location.pathname + window.location.search !== lpFacetRendered) window.location.reload();
    });
  }

  document.querySelectorAll(".sort-dropdown").forEach((dropdown) => {
    const button = dropdown.querySelector("button");
    const menu = dropdown.querySelector(".dropdown-menu");

    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) menu.style.display = "none";
    });

    button.addEventListener("click", function (e) {
      e.preventDefault();
      menu.style.display = menu.style.display === "block" ? "none" : "block";
    });

    dropdown.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("change", function () {
        menu.style.display = "none";
        setTimeout(() => applySorting(this.value), 100);
      });
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const currentSortBy = urlParams.get("sort_by");
  if (currentSortBy) {
    setTimeout(() => updateSortDropdownState(currentSortBy), 100);
  }

  document.querySelectorAll(".filter-group").forEach((group) => {
    const count = group.querySelectorAll('input[type="checkbox"]:checked').length;
    if (count > 0) {
      const title = group.querySelector("h4");
      if (title) {
        const badge = document.createElement("span");
        badge.className = "filter-count ml-2";
        badge.textContent = `(${count})`;
        title.appendChild(badge);
      }
    }
  });

  function handleMobileLayout() {
    const sidebar = document.querySelector(".filter-sidebar");
    if (window.innerWidth < 1024 && sidebar) {
      const sidebarHeader = sidebar.querySelector("h3");
      if (sidebarHeader && !sidebarHeader.dataset.mobileToggle) {
        sidebarHeader.dataset.mobileToggle = "true";
        sidebarHeader.style.cursor = "pointer";
        sidebarHeader.addEventListener("click", function () {
          const form = sidebar.querySelector("form");
          form.style.display = form.style.display === "none" ? "block" : "none";
        });
      }
    }
  }

  handleMobileLayout();
  window.addEventListener("resize", handleMobileLayout);
  window.addEventListener("load", () => setTimeout(checkAndHideSorting, 100));
});

// LibertyPaw 2026-09-25 (audit item A24): filter/sort requests share one pipeline.
// Only the newest request is used, a request that takes over 15 s is dropped and the
// page navigates normally instead, and any failure also falls back to a normal page
// load. Both filter forms are refreshed so counts and disabled options stay correct.
let lpFacetRequest = 0;
let lpFacetController = null;
let lpFacetPendingUrl = null;
let lpFacetRendered = null;
const LP_PRICE_ORDER_ERROR = "The minimum price can't be higher than the maximum price.";

function clearFilterForm(form) {
  Array.from(form.elements).forEach((control) => {
    if (!control.name || control.name.indexOf("filter.") !== 0) return;
    if (control.type === "checkbox" || control.type === "radio") control.checked = false;
    else control.value = "";
  });
}

function syncFilterForms(source) {
  const data = new FormData(source);
  document.querySelectorAll("#Facet-Filters-Form, #Facet-Filters-Form-Mobile").forEach((form) => {
    if (form === source) return;
    Array.from(form.elements).forEach((control) => {
      if (!control.name || control.name.indexOf("filter.") !== 0) return;
      if (control.type === "checkbox" || control.type === "radio") {
        control.checked = data.getAll(control.name).includes(control.value);
      } else {
        control.value = data.get(control.name) || "";
      }
    });
  });
}

function validateFacetPrices(form) {
  const min = form.querySelector('input[name="filter.v.price.gte"]');
  const max = form.querySelector('input[name="filter.v.price.lte"]');
  if (min) min.setCustomValidity("");
  if (max) max.setCustomValidity("");
  if (min && max && min.value !== "" && max.value !== "" && Number(min.value) > Number(max.value)) {
    const holder = form.closest("[data-lp-price-range-error]");
    min.setCustomValidity((holder && holder.dataset.lpPriceRangeError) || LP_PRICE_ORDER_ERROR);
  }
  return form.reportValidity();
}

function facetUrl(form) {
  const url = new URL(lpFacetPendingUrl || window.location.href, window.location.origin);
  url.hash = "";
  url.searchParams.delete("page");
  if (form) {
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (key.indexOf("filter.") === 0) url.searchParams.delete(key);
    });
    for (const [key, value] of new FormData(form)) {
      if (key.indexOf("filter.") === 0 && value !== "") url.searchParams.append(key, value);
    }
  }
  return url;
}

// AJAX Sort
async function applySorting(sortValue) {
  const url = facetUrl();
  url.searchParams.set("sort_by", sortValue);
  return updateFacets(url);
}

// AJAX Filter
async function applyFilters(form) {
  if (!form || !form.matches) {
    form = document.getElementById("Facet-Filters-Form") || document.getElementById("Facet-Filters-Form-Mobile");
  }
  if (!form) return;
  if (!validateFacetPrices(form)) return;
  syncFilterForms(form);
  return updateFacets(facetUrl(form));
}

function lpFacetBusy(on) {
  const toggle = (sel, cls) => document.querySelector(sel)?.classList[on ? "add" : "remove"](cls);
  toggle(".filter-sidebar", "loading");
  toggle(".sort-dropdown", "loading");
  toggle("#facets-results", "updating");
  toggle(".product-grid-main", "loading");
  const grid = document.querySelector("#facets-results");
  if (grid) { if (on) grid.setAttribute("aria-busy", "true"); else grid.removeAttribute("aria-busy"); }
}

async function updateFacets(url) {
  const request = ++lpFacetRequest;
  if (lpFacetController) lpFacetController.abort();
  const controller = new AbortController();
  lpFacetController = controller;
  let timedOut = false;
  const timer = window.setTimeout(() => { timedOut = true; controller.abort(); }, 15000);
  const target = url.pathname + url.search;
  lpFacetPendingUrl = url.href;
  lpFacetBusy(true);

  try {
    const response = await fetch(target, { signal: controller.signal });
    if (!response.ok) throw new Error("Filter request failed: " + response.status);
    const html = await response.text();
    if (request !== lpFacetRequest) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newGrid = doc.querySelector("#facets-results");
    const currentGrid = document.querySelector("#facets-results");
    if (!newGrid || !currentGrid) throw new Error("Missing product results");

    currentGrid.innerHTML = newGrid.innerHTML;

    // Refresh the filter forms (counts, disabled values) and keep desktop focus.
    document.querySelectorAll("#Facet-Filters-Form, #Facet-Filters-Form-Mobile").forEach((form) => {
      const nextForm = doc.getElementById(form.id);
      if (!nextForm) return;
      const active = document.activeElement;
      const keep = form.id === "Facet-Filters-Form" && form.contains(active) && active.name
        ? { name: active.name, value: active.value, type: active.type } : null;
      form.innerHTML = nextForm.innerHTML;
      if (keep) {
        const next = Array.from(form.elements).find((c) => c.name === keep.name &&
          ((keep.type !== "checkbox" && keep.type !== "radio") || c.value === keep.value));
        if (next && !next.disabled) next.focus({ preventScroll: true });
      }
    });

    const newCount = doc.querySelector(".product-count");
    const currentCount = document.querySelector(".product-count");
    if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;

    const newPagination = doc.querySelector("nav.pagination");
    const currentPagination = document.querySelector("nav.pagination");
    if (currentPagination && !currentGrid.contains(currentPagination)) {
      if (newPagination) currentPagination.innerHTML = newPagination.innerHTML;
      else currentPagination.remove();
    } else if (!currentPagination && newPagination && !currentGrid.contains(newPagination)) {
      document.querySelector(".product-grid-main")?.appendChild(newPagination);
    }

    if (target !== window.location.pathname + window.location.search) {
      window.history.pushState({ lpFacets: true }, "", target);
    }
    lpFacetRendered = target;
    updateSortDropdownState(url.searchParams.get("sort_by") || "");
    checkAndHideSorting();
    if (window.initializeProductTiles) window.initializeProductTiles();
    document.dispatchEvent(new CustomEvent("lp:facets:updated"));
  } catch (error) {
    if (request === lpFacetRequest && (error.name !== "AbortError" || timedOut)) {
      window.location.assign(target);
    }
  } finally {
    window.clearTimeout(timer);
    if (request === lpFacetRequest) {
      lpFacetBusy(false);
      lpFacetPendingUrl = null;
    }
  }
}
function updateSortDropdownState(sortValue) {
  const sortDropdown = document.querySelector(".sort-dropdown");
  if (!sortDropdown) return;
  const button = sortDropdown.querySelector("button span");
  if (button) {
    let selectedName = "Sort by";
    sortDropdown.querySelectorAll('input[name="sort_by"]').forEach((option) => {
      if (option.value === sortValue) {
        const label = option.closest("label")?.querySelector("span");
        if (label) selectedName = label.textContent.trim();
      }
    });
    button.textContent = selectedName;
  }
  sortDropdown.querySelectorAll('input[type="radio"]').forEach((radio) => {
    radio.checked = radio.value === sortValue;
  });
}

function checkAndHideSorting() {
  const productList = document.querySelector("#facets-results ul");
  const sortDropdown = document.querySelector(".sort-dropdown");
  const noProductsMsg = document.querySelector("#facets-results p");
  const hasNoProducts = !productList || productList.children.length === 0 ||
    (noProductsMsg && noProductsMsg.textContent.toLowerCase().includes("no products"));
  if (sortDropdown) sortDropdown.style.display = hasNoProducts ? "none" : "block";
}

// Kept for any markup that still calls these (e.g. the left-drawer filters snippet).
// LibertyPaw 2026-09-25 (audit item A24): they now act on the form that was used.
window.Filterable = {
  init() {
    this.loading = false;
    checkAndHideSorting();
  },
  async filterFormSubmit(event) {
    event.preventDefault();
    const el = event.currentTarget || event.target;
    applyFilters(el && (el.form || (el.closest && el.closest("form"))));
    if (this.mobileFilterOpen) this.mobileFilterOpen = false;
  },
  clearAllFilters(event) {
    event.preventDefault();
    const el = event.currentTarget || event.target;
    const form = (el && el.closest && el.closest("form")) || document.getElementById("Facet-Filters-Form-Mobile");
    if (form) clearFilterForm(form);
    applyFilters(form);
    if (this.mobileFilterOpen) this.mobileFilterOpen = false;
  },
};